import React, { useCallback } from 'react';

// Components
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import Switch from '@material-ui/core/Switch';

interface Props {
  onChange: (key: string, value: boolean) => void;
  value: boolean;
}

function Pronunciation({ onChange, value }: Props) {
  const enabled = !!value;

  const handleChangeEnabled = useCallback(
    function(e, isEnabled) {
      onChange('client.settings.namePronunciation.enabled', isEnabled);
    },
    [onChange],
  );

  return (
    <Card>
      <CardHeader
        title="Name Pronunciation"
        action={
          <Switch
            inputProps={{ 'aria-label': 'pronunciation switch' }}
            onChange={handleChangeEnabled}
            checked={enabled}
          />
        }
        subheader="Allow people in your organization to add a recording of their full name to their
            profile."
      />
    </Card>
  );
}

export default Pronunciation;
